<script setup>
const { gtag } = useGtag()
const button = {
  text: '解析をはじめる',
  link: '/registration/',
  isActive: true
}

const list = [
  '写真を送信してから解析結果が出るまでに30秒前後時間がかかることがあります。',
  '桜（ソメイヨシノ）のつぼみの写真を用いることを想定しています。',
  '今シーズンは試行段階のコンテンツになります。解析結果はあくまで予想であり、実際の開花日と異なる場合がありますのでご了承ください。',
  '公序良俗に反する写真、著作権侵害にあたる写真でのご利用はお控えください。',
]

const isAndroid = ref(false)
const akey = ref('')
onMounted(() => {
  if(!navigator.userAgent.includes('weathernews')) {
    location.href = '/sakura/'
  }
  const userAgent = navigator.userAgent
  akey.value = wniutil.get_akey_v2()
  if (/android/i.test(userAgent)) {
    isAndroid.value = true
  }
  const runtimeConfig = useRuntimeConfig()
  gtag('config', runtimeConfig.public.gtag.id, getGtagConfig())
})

useHead({
  title: '桜AI開花予想 | ウェザーニュース',
  meta: [
  { name: 'description', content: "" },
    { property: 'og:image', content: "https://gvs.weathernews.jp/s/sakura/img/2025/sakura_sns_hd_ai.jpg" },
  ],
})
</script>

<template>
  <div class="top">
    <h1>
      <img src="/assets/img/image_logo.svg" width="357" height="70" alt="桜AI開花予想">
    </h1>
    <div class="box">
      <div class="inner">
        <h2 class="heading">桜のつぼみ画像から開花日を予想します</h2>
        <p class="lead">お花見を楽しめるのはいつ頃か、調べてみよう！</p>
      </div>
      <div class="inner">
        <!-- <CommonButton v-if="akey" :button="button" :isAndroid="isAndroid" :akey="akey"></CommonButton> -->
        <NoticeBox />
        <NuxtLink v-if="akey" to="/forecast/history/" class="link">これまでの結果</NuxtLink>
      </div>
    </div>
    <CommonNote :list="list"></CommonNote>
    <NuxtLink to="https://weathernews.jp/sakura/" class="footer__link">さくら開花情報トップ</NuxtLink>
  </div>
</template>

<style lang="scss" scoped>
.top {
  @include wrap();
  @include flex-column();
  align-items: center;
  justify-content: center;
  gap: 30px;
  min-height: 100svh;
  & > * {
    position: relative;
  }
  .box {
    @include flex-column();
    @include box();
    // padding-inline: 8px;
  }
  .inner {
    @include flex-column();
    gap: 10px;
    align-items: center;
  }
  .heading {
    color: $font;
    text-align: center;
    font-size: 16px;
    font-weight: 600;
    line-height: 1em;
  }
  .lead {
    color: $font;
    // font-size: 13px;
    font-size: 14px;
    font-weight: 600;
    line-height: 1.5em;
  }
  .link {
    color: $wni;
    text-align: center;
    font-size: 14px;
    font-weight: 600;
    line-height: 1em;
    text-decoration: underline;
  }
  .footer__link {
    /* width: calc(100% + 20px); */
    width: 100%;
    padding: 20px;
    background-color: $white;
    color: $strong;
    font-size: 15px;
    font-weight: 700;
    line-height: 18px;
    text-align: center;
    position: absolute;
    bottom:0 ;
  }
}
</style>
